/* eslint-disable max-len */
import React, { useState } from 'react';
import SelectLocationView from "./SelectLocationView.js";
import EnableDataSharingView from "./EnableDataSharingView.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AcceptTransferFlowView(props) {
  const {
    onClose,
    parentIncomingTransfer,
    reloadData
  } = props;
  const [flowStep, setFlowStep] = useState('selectLocation');
  const [locationId, setLocationId] = useState();
  if (flowStep === 'selectLocation') {
    return /*#__PURE__*/_jsx(SelectLocationView, {
      onClose: onClose,
      parentIncomingTransfer: parentIncomingTransfer,
      setFlowStep: setFlowStep,
      locationId: locationId,
      setLocationId: setLocationId
    });
  }
  return /*#__PURE__*/_jsx(EnableDataSharingView, {
    onClose: onClose,
    reloadData: reloadData,
    parentIncomingTransfer: parentIncomingTransfer,
    locationId: locationId
  });
}